import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col md:flex-row justify-between gap-6 px-6 py-8 bg-gray-50">
        {/* Disclaimer Section */}
        <div className="flex-[2]  p-6 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">Privacy Policy</h2>
          <p className="font-semibold mb-2">Who we are</p>
          <p className="text-gray-700 mb-4">
            Our website address is: https://solarissurge.net
          </p>
          <p className="font-semibold mb-2">
            What personal data we collect and why we collect it
          </p>
          <p className="font-semibold mb-2">Comments</p>
          <p className="text-gray-700">
            When visitors leave comments on the site we collect the data shown
            in the comments form, and also the visitor’s IP address and browser
            user agent string to help spam detection. An anonymized string
            created from your email address (also called a hash) may be provided
            to the Gravatar service to see if you are using it. The Gravatar
            service privacy policy is available here:
            https://automattic.com/privacy/. After approval of your comment,
            your profile picture is visible to the public in the context of your
            comment. If you leave a comment, the comment and its metadata are
            retained indefinitely. This is so we can recognize and approve any
            follow-up comments automatically instead of holding them in a
            moderation queue.
          </p>
          <br />
          <p className="font-semibold mb-2">
            Embedded content from other websites
          </p>
          <p className="text-gray-700">
            Articles on this site may include embedded content (e.g. videos,
            images, articles, etc.). Embedded content from other websites
            behaves in the exact same way as if the visitor has visited the
            other website. These websites may collect data about you, use
            cookies, embed additional third-party tracking, and monitor your
            interaction with that embedded content, including tracking your
            interaction with the embedded content if you have an account and are
            logged in to that website.
          </p>
        </div>

        {/* About Me Section */}
        <div className="flex-[1] bg-white shadow-md p-6 rounded-lg max-w-sm">
          <div className="flex flex-col items-center text-center">
            <img
              src="/Assets/man.webp" // Replace with your actual image URL
              alt="About Me"
              className="w-32 h-32 rounded-full mb-4"
            />
            <h3 className="text-lg font-bold">About Me</h3>
            <p className="text-gray-700 mt-2">
              Welcome to Solarissurge.net! I'm the driving force behind this
              site, which attracts over 1,000 daily visitors interested in solar
              energy. I'm also the author of a popular solar energy book, with
              over 80,000 copies sold and more than 2,000 reviews averaging 4.5
              stars. My mission is to demystify solar power and make it
              accessible to everyone. Join me in exploring the potential of
              solar power to create a cleaner, brighter future! Link to the book
              on Amazon. Read more about me here, check out my Youtube channel,
              or send me a message..
            </p>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
